/**
 * components/import/statements/StatusBadge.jsx — Phase 84.3 slice-1
 *
 * Tiny status pill used in the bulk-backfill queue. Extracted verbatim
 * from pages/CSVImport.js (was internal function `StatusBadge`).
 * Zero behavior change.
 */
import React from 'react';

export default function StatusBadge({ status }) {
  const map = {
    queued:    { label: 'Queued',    cls: 'bg-muted text-muted-foreground' },
    reading:   { label: 'Submitting',cls: 'bg-[hsl(var(--gold))]/15 text-[hsl(var(--gold))]' },
    submitted: { label: 'Submitted', cls: 'bg-primary/15 text-primary' },
    importing: { label: 'Importing', cls: 'bg-primary/15 text-primary' },
    done:      { label: 'Done',      cls: 'bg-emerald-500/15 text-emerald-600' },
    failed:    { label: 'Failed',    cls: 'bg-destructive/15 text-destructive' },
  };
  const m = map[status] || map.queued;
  return <span className={`rounded-full px-2 py-0.5 text-[10px] ${m.cls}`}>{m.label}</span>;
}
